// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-words-container {
  /*width: 99vw;
  height: calc(100vh - 245px);
  overflow: hidden;
  position: relative;
  margin: 0 auto 10px auto;
  padding: 0 10px;*/

  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  /* overflow: hidden removed to allow card view scrolling */
}
  
.grid-button-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.grid-button-transparent {
  background-color: transparent;
  font-size: 20px;
  cursor: pointer;
  z-index: 1000;
  height:70%;
  display: flex;
  justify-content: center;   /* vízszintes közép */
  align-items: center;       /* függőleges közép */
  width:90%;
}
.icon {
  color: #3182ce;
}
.icon-red {
  color: red;
  font-size: 18px;
}
.icon:hover, .icon-red:hover {
  transform: scale(1.5);
}

.loading-indicator {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  z-index:1000;
}
/* Pörögő animáció a modal alatt */
.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 120px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-buttons {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.confirm-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.cancel-button {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.Toastify__toast-container {
  z-index: 2000 !important; /* Magasabb, mint a modalé */
}

/* Card list + fine position scrubber (for 100k+ words) */
.aw-list-layout {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  flex: 1 1;
  max-height: none;
  gap: 6px;
  min-height: 0;
  padding: 8px;
  box-sizing: border-box;
  outline: none;
  border-radius: 10px;
}

.aw-list-layout:focus,
.aw-list-layout:focus-visible {
  box-shadow: inset 0 0 0 2px #3182ce;
}

.card-view-container {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  /* Virtual window is driven by the scrubber — hide native scrollbar */
  scrollbar-width: none;
}

.card-view-container::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

.aw-scrubber {
  width: 30px;
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-height: 0;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-sizing: border-box;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.aw-scrubber__btn {
  width: 100%;
  height: 24px;
  flex: none;
  border: none;
  background: transparent;
  color: #475569;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.aw-scrubber__btn--page {
  height: 28px;
  color: #1c6bb0;
  border-bottom: 1px solid #e2e8f0;
}

.aw-scrubber__btn--page:last-child {
  border-bottom: none;
  border-top: 1px solid #e2e8f0;
}

.aw-scrubber__icon {
  display: block;
  flex: none;
}

.aw-scrubber__btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.aw-scrubber__btn--page:hover:not(:disabled) {
  background: #dbeafe;
  color: #155489;
}

.aw-scrubber__btn:disabled {
  opacity: 0.35;
  cursor: default;
}

.aw-scrubber__track {
  position: relative;
  flex: 1 1;
  width: 100%;
  min-height: 40px;
  cursor: pointer;
  background: transparent;
}

.aw-scrubber__thumb {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background: #3182ce;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.35);
  box-sizing: border-box;
  pointer-events: none;
  z-index: 1;
}

.aw-scrubber__thumb:active,
.aw-scrubber__track:active .aw-scrubber__thumb {
  background: #1c6bb0;
}

.word-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.word-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
`, "",{"version":3,"sources":["webpack://./src/Topics/ActiveWords.css"],"names":[],"mappings":"AAAA;EACE;;;;;mBAKiB;;EAEjB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,aAAa;EACb,UAAU;EACV,aAAa;EACb,uBAAuB,IAAI,qBAAqB;EAChD,mBAAmB,QAAQ,qBAAqB;EAChD,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;AACA,kCAAkC;AAClC;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB,EAAE,4BAA4B;AACxD;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,qEAAqE;EACrE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC","sourcesContent":[".topic-words-container {\r\n  /*width: 99vw;\r\n  height: calc(100vh - 245px);\r\n  overflow: hidden;\r\n  position: relative;\r\n  margin: 0 auto 10px auto;\r\n  padding: 0 10px;*/\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  /* overflow: hidden removed to allow card view scrolling */\r\n}\r\n  \r\n.grid-button-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.grid-button-transparent {\r\n  background-color: transparent;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  z-index: 1000;\r\n  height:70%;\r\n  display: flex;\r\n  justify-content: center;   /* vízszintes közép */\r\n  align-items: center;       /* függőleges közép */\r\n  width:90%;\r\n}\r\n.icon {\r\n  color: #3182ce;\r\n}\r\n.icon-red {\r\n  color: red;\r\n  font-size: 18px;\r\n}\r\n.icon:hover, .icon-red:hover {\r\n  transform: scale(1.5);\r\n}\r\n\r\n.loading-indicator {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 10px;\r\n  color: #fff;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  border-radius: 5px;\r\n  z-index:1000;\r\n}\r\n/* Pörögő animáció a modal alatt */\r\n.spinner {\r\n  border: 4px solid rgba(255, 255, 255, 0.3);\r\n  border-top: 4px solid white;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  animation: spin 1s linear infinite;\r\n  margin-top: 120px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.modal-buttons {\r\n  margin-top: 15px;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n.confirm-button {\r\n  background-color: #ef4444;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cancel-button {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.Toastify__toast-container {\r\n  z-index: 2000 !important; /* Magasabb, mint a modalé */\r\n}\r\n\r\n/* Card list + fine position scrubber (for 100k+ words) */\r\n.aw-list-layout {\r\n  display: flex;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  height: 100%;\r\n  flex: 1;\r\n  max-height: none;\r\n  gap: 6px;\r\n  min-height: 0;\r\n  padding: 8px;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.aw-list-layout:focus,\r\n.aw-list-layout:focus-visible {\r\n  box-shadow: inset 0 0 0 2px #3182ce;\r\n}\r\n\r\n.card-view-container {\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  height: 100%;\r\n  /* Virtual window is driven by the scrubber — hide native scrollbar */\r\n  scrollbar-width: none;\r\n}\r\n\r\n.card-view-container::-webkit-scrollbar {\r\n  width: 0;\r\n  height: 0;\r\n  display: none;\r\n}\r\n\r\n.aw-scrubber {\r\n  width: 30px;\r\n  flex: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 0;\r\n  background: #f1f5f9;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  box-sizing: border-box;\r\n  user-select: none;\r\n  touch-action: none;\r\n}\r\n\r\n.aw-scrubber__btn {\r\n  width: 100%;\r\n  height: 24px;\r\n  flex: none;\r\n  border: none;\r\n  background: transparent;\r\n  color: #475569;\r\n  font-size: 10px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.aw-scrubber__btn--page {\r\n  height: 28px;\r\n  color: #1c6bb0;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.aw-scrubber__btn--page:last-child {\r\n  border-bottom: none;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n.aw-scrubber__icon {\r\n  display: block;\r\n  flex: none;\r\n}\r\n\r\n.aw-scrubber__btn:hover:not(:disabled) {\r\n  background: #e2e8f0;\r\n  color: #0f172a;\r\n}\r\n\r\n.aw-scrubber__btn--page:hover:not(:disabled) {\r\n  background: #dbeafe;\r\n  color: #155489;\r\n}\r\n\r\n.aw-scrubber__btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: default;\r\n}\r\n\r\n.aw-scrubber__track {\r\n  position: relative;\r\n  flex: 1;\r\n  width: 100%;\r\n  min-height: 40px;\r\n  cursor: pointer;\r\n  background: transparent;\r\n}\r\n\r\n.aw-scrubber__thumb {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-radius: 50%;\r\n  background: #3182ce;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.35);\r\n  box-sizing: border-box;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n.aw-scrubber__thumb:active,\r\n.aw-scrubber__track:active .aw-scrubber__thumb {\r\n  background: #1c6bb0;\r\n}\r\n\r\n.word-card {\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.word-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
